import styled, { css } from "styled-components";
import { device } from "../../styles/mediaQueries";

const MobileHeaderModifiers = {
  full: (theme) => css`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    margin: 0;
  `,
  clean: (theme) => css`
    display: grid;
    grid-template-columns: 1fr 3fr 1fr;
    align-items: center;

    .logo {
      justify-self: center;
    }
  `,
  transparent: (theme) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: transparent;
    position: relative;
    height: 60px;
    margin-bottom: -60px;
    z-index: 99;
  `,
  minimal: (theme) => css`
    height: 60px;
  `,
};

export const Wrapper = styled.div`
  ${({ theme, variant }) => css`
    .logo {
      cursor: pointer;
    }
    @media (${device.laptop}) {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0;
      min-height: 80px;
      .logo img {
        height: 60px;
      }
      .formSearch {
        width: 65%;
        max-width: 450px;
        position: relative;
      }
    }

    ${variant && MobileHeaderModifiers[variant](theme)}
  `}
`;

export const Icons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 25px;
  font-size: 1rem;
  padding: 0 10px;

  svg,
  span,
  .search-control {
    cursor: pointer;
  }

  .search-control {
    background: none;
    border: none;
    color: #fff;
  }

  .search-control:hover,
  svg:hover,
  span:hover {
    transition: all 0.2s ease-out;
    color: #cff16b;
  }

  .search-control span {
    display: none;
    font-size: 14px;
    margin: 0 3px;
  }

  @media (min-width: 993px) {
    .search-control span {
      display: inline;
    }
  }

  @media (min-width: 768px) {
    font-size: 1.5rem;
  }
`;

export const Text = styled.a`
  text-transform: uppercase;
  color: #cff16b !important;
  font-size: 13px;
  font-weight: bold;
  cursor: pointer;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;
